import { AttributionControl } from "maplibre-gl";
export class OsmAttributionControl extends AttributionControl {
    constructor(options) {
        super(OsmAttributionControl.buildOptions(options));
        this.elementId = OsmAttributionControl.defaultElementId;
        this.path = OsmAttributionControl.defaultPath;
        if (typeof options != "undefined" &&
            typeof options.editButton != "undefined") {
            this.elementId = options.editButton.elementId || this.elementId;
            this.path = options.editButton.path || this.path;
        }
    }
    static buildOptions(options) {
        // build button options.
        let buttonOptions = {
            elementId: OsmAttributionControl.defaultElementId,
            path: OsmAttributionControl.defaultPath,
            svg: "assets/icons/edit.svg"
        };
        if (typeof options != "undefined" &&
            typeof options.editButton != "undefined") {
            buttonOptions.elementId = options.editButton.elementId || buttonOptions.elementId;
            buttonOptions.path = options.editButton.path || buttonOptions.path;
            buttonOptions.svg = options.editButton.svg || buttonOptions.svg;
        }
        else {
            buttonOptions = undefined;
        }
        // build super options 
        const superOptions = {
            customAttribution: []
        };
        if (typeof options != "undefined") {
            if (typeof options.customAttribution == "string") {
                superOptions.customAttribution.push(options.customAttribution);
            }
            else {
                options.customAttribution.forEach(a => {
                    superOptions.customAttribution.push(a);
                });
            }
            superOptions.compact = options.compact || superOptions.compact;
        }
        if (typeof buttonOptions !== "undefined") {
            superOptions.customAttribution.push(`<a id="${buttonOptions.elementId}" href="${buttonOptions.path}" target="_blank">
                <img src="${buttonOptions.svg}"/>
            </a>`);
        }
        return superOptions;
    }
    onAdd(map) {
        this.map = map;
        // register move event to update edit location.
        this.map.on("load", (e) => { this._updateEditLocation(); });
        this.map.on("moveend", (e) => { this._updateEditLocation(); });
        return super.onAdd(map);
    }
    _updateEditLocation() {
        const element = document.getElementById(this.elementId);
        if (typeof element === "undefined")
            return;
        if (element === null)
            return;
        element.href = `${this.path}#map=${this.map.getZoom() + 1}/${this.map.getCenter().lat}/${this.map.getCenter().lng}`;
    }
}
OsmAttributionControl.defaultElementId = "attribution-osm-edit-button";
OsmAttributionControl.defaultPath = "https://www.openstreetmap.org/edit";
